var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-label',{class:_vm.$style.label,attrs:{"for":_vm.id}},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()]),_vm._v(" "),_c('base-textarea',_vm._g(_vm._b({attrs:{"id":_vm.id}},'base-textarea',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }